import React from 'react';
import AppSwitcherIcon from '@atlaskit/icon/core/app-switcher';
import SingleSelectField from '@atlassian/jira-issue-create-commons/src/ui/single-select-field/index.tsx';
import type { SelectOption } from '@atlassian/jira-issue-field-select/src/ui/edit/types.tsx';
import { CATEGORY_TYPE } from '@atlassian/jira-platform-field-config/src/index.tsx';
import { DropdownFieldPlaceholder } from '../../../ui/field-placeholders/index.tsx';
import type { FieldTypeConfig, ProvidedFieldProps } from '../types.tsx';
import { selectFieldWriter } from '../writers/index.tsx';

const CategoryFieldTypeComponent = (props: ProvidedFieldProps) => (
	<SingleSelectField {...props} defaultValue={undefined} />
);

export const CategoryFieldTypeConfig: FieldTypeConfig<SelectOption> = {
	icon: AppSwitcherIcon,
	type: CATEGORY_TYPE,
	Component: CategoryFieldTypeComponent,
	placeholder: <DropdownFieldPlaceholder />,
	writer: selectFieldWriter,
};
